import _ from 'lodash';
import React, { Component } from 'react';

import {
  getOptionValueForSelect
} from '../../util';

import Select from 'react-select';

class UserSelect extends Component {

  getUsersOptions(){

    const noUserOption = {
      value: null,
      label: 'None'
    }

    const userOptions = _.map(this.props.users, user => {
      return {
        value: user._id,
        label: `${user.firstName} ${user.lastName}`
      }
    });

    return _.union(this.props.allowNull && noUserOption, userOptions);
  }

  render(){
    const usersOptions = this.getUsersOptions();

    return (
      <Select
        classNamePrefix={'react-select'}
        className={`react-select-container member-select ${!this.props.selectedUser && 'none-selected'}`}
        value={getOptionValueForSelect(usersOptions, this.props.selectedUser)}
        options={usersOptions}
        onChange={(option) => { this.props.selectUser(option.value) }}
        isSearchable={false}
        isSearchable={true}
        isDisabled={this.props.disabled}
      />
    )
  }
}

export default UserSelect;



// WEBPACK FOOTER //
// ./src/components/shared/userSelect.js